module.exports = __webpack_public_path__ + "img/137-fiji.28ca4737.svg";